import {handleRequest} from './base';

const AccountRepo = {
  fetch: bizID => {
    return handleRequest({
      method: 'get',
      url: `/api/business/${bizID}/accounts`,
    })
  },

  update: (business, account, {meta}) => {
    return handleRequest({
      method: 'put',
      url: `/api/business/${business.id}/accounts/${account.id}`,
      data: {
        meta: meta,
      }
    })
  }
};

export default AccountRepo;